import { cx } from "class-variance-authority";

type ValidationMessageProps = {
  shouldShowValidation?: boolean;
  validationMessage?: string;
};

export const ValidationMessage = (props: ValidationMessageProps) => {
  if (!props.shouldShowValidation || !props.validationMessage) return null;
  return (
    <p className={cx("text-ui-red text-sm italic")}>
      {props.validationMessage}
    </p>
  );
};
